module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcontractors.net.au/images/our_services_2-50cbc1f9678c15c0edaaccc8a3d3c9f0.jpg";